import { Navigate, useLocation } from "react-router-dom";

/** Redirects a legacy per-product integrations surface to the unified hub. */
export function IntegrationsHubRedirect({
  to,
  products,
}: {
  to: string;
  /** Pre-filters the hub to this product, as the old nav entry did. */
  products?: string;
}) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  if (products) {
    params.set("products", products);
  }
  const query = params.toString();
  return <Navigate replace to={query ? `${to}?${query}` : to} />;
}
